const Global = {
    socketPort:6002,
    wsHost: 'demo.bubble-in.com',
    hotjar: {
        prodID: "3848159",
        testID: "3859258"
    }
}
export default Global;
